import React from "react";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { useTabQuery } from "hooks/useQueryState";
import { TemplatesTab } from "./templates/TemplatesTab";
import { DraftsTab } from "./drafts/DraftsTab";
import { OnlinesTab } from "./onlines/OnlinesTab";
import { ToningsTab } from "./tonings/ToningsTab";

const Spine = () => {
  const [tab, setTab] = useTabQuery("spineTab", "templates");

  return (
    <Tabs value={tab} onValueChange={setTab} className="flex-1 space-y-4">
      <div className="flex items-center gap-8">
        <h2 className="text-3xl font-bold tracking-tight">Spine Templates</h2>
        <TabsList>
          <TabsTrigger value="templates">Templates</TabsTrigger>
          <TabsTrigger value="draft">Drafts</TabsTrigger>
          <TabsTrigger value="onlines">Onlines</TabsTrigger>
          <TabsTrigger value="tonings">Tonings</TabsTrigger>
        </TabsList>
      </div>
      <TabsContent value="templates">
        <TemplatesTab />
      </TabsContent>
      <TabsContent value="draft">
        <DraftsTab />
      </TabsContent>
      <TabsContent value="onlines">
        <OnlinesTab />
      </TabsContent>
      <TabsContent value="tonings">
        <ToningsTab />
      </TabsContent>
    </Tabs>
  );
};

export default Spine;
